<script>
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import MenuIcons from "../components/MenuIcons.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Slider from "../components/Slider.svelte";
  import ChartTraffict from "../components/charts/ChartTraffict.svelte";
  import HotspotLogs from "../components/hotspot/HotspotLogs.svelte";
  import CardBar from "../components/CardBar.svelte";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
</script>

<svelte:head>
  <title>Mikhub - Dashboard</title>
</svelte:head>
{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:px-5 lg:pt-24 md:pt-20"
>
  <div class="flex flex-wrap items-center pt-3 mx-auto center lg:my-0">
    <!--Main Col-->
    <Slider />
    <!--Img Col-->
    <MenuIcons />
  </div>

  <div class="mx-auto my-2 lg:my-2">
    <Title title="Summary" subtitle="View More" tipe="3" href="./summary" />
    <CardBar />

    <div class="block w-full gap-2 lg:flex md:flex">
      <div class="w-full lg:w-1/2 md:w-1/2">
        <ChartTraffict />
      </div>
      <div class="w-full lg:w-1/2 md:w-1/2">
        <HotspotLogs />
      </div>
    </div>
  </div>
</main>
